import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Sleep hacking",
  "description": "",
  "published": "2011-11-03T00:00:00.000Z",
  "redirect_from": ["/blog/sleep-hacking/swizec/2851"],
  "categories": "Bedtime, Circadian rhythm, Health, IPhone, Polyphasic sleep, Sleep, Sleep Cycle, Sleep disorder, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/11/photo-1.png",
        "alt": null,
        "title": "Puts you to bed nicely"
      }}></img></p>
    <p>{`Waging war with sleep is very tiring business and I've been doing it pretty much as long as I can remember. My daily 750words are littered with battle reports, my twitter stream gets constantly barraged with updates from the war effort and I think it's pretty safe to say that I may have tried more different things than most people to stave off the foe.`}</p>
    <p>{`Some things I've tried so far:`}</p>
    <ul>
      <li parentName="ul">{`drinking tea like it was water`}</li>
      <li parentName="ul">{`eating `}<a parentName="li" {...{
          "href": "http://en.wikipedia.org/wiki/Caffeine_tablets",
          "title": "Caffeine tablets"
        }}>{`caffeine pills`}</a>{` before going to bed`}</li>
      <li parentName="ul">{`drinking `}<a parentName="li" {...{
          "href": "http://en.wikipedia.org/wiki/Energy_drink",
          "title": "Energy drink"
        }}>{`energy drinks`}</a>{` by the gallon`}</li>
      <li parentName="ul">{`phone alarms`}</li>
      <li parentName="ul">{`computer alarms that force me to get out of bed to turn them off`}</li>
      <li parentName="ul">{`cluster alarms - even five in 20 minute intervals`}</li>
      <li parentName="ul">{`meditation (`}<a parentName="li" {...{
          "href": "http://en.wikipedia.org/wiki/Polyphasic_sleep",
          "title": "Polyphasic sleep"
        }}>{`polyphasic sleep`}</a>{` of sorts?)`}</li>
      <li parentName="ul">{`going to bed early`}</li>
    </ul>
    <p>{`Nothing works.`}</p>
    <p>{`No matter how hard I try to sync my `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Circadian_rhythm",
        "title": "Circadian rhythm"
      }}>{`circadian rhythms`}</a>{` with something even remotely appropriate by society's standards I will eventually always slip back into my habit of going to bed at 3am and waking up at 9am at the earliest.`}</p>
    <p>{`Sometimes it drifts even farther and it becomes practically impossible to wake up before 11am ... and no, going to bed early doesn't help; I just don't fall asleep and why waste the time just lying in bed like that?`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/11/photo.png",
        "alt": null,
        "title": "Shiny graphs and analytics"
      }}></img></p>
    <p>{`But! I think I may finally have found a solution - an iPhone app that's a bit smart about handling sleep.`}</p>
    <h2 {...{
      "id": "sleep-cycle"
    }}>{`Sleep Cycle`}</h2>
    <p><a parentName="p" {...{
        "href": "http://www.mdlabs.se/sleepcycle/"
      }}>{`Sleep Cycle`}</a>{` is the best `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Alarm_clock",
        "title": "Alarm clock"
      }}>{`alarm clock`}</a>{` I have ever used. Not only do I get to snuggle with my iphone when I'm sleeping, it also tracks my movements over night to figure out when is the best time to give waking me up a shot.`}</p>
    <p>{`Plus there are statistics of how I'm sleeping. Scoar!`}</p>
    <p>{`And it actually works even for heavy sleeprs living in their own timezone like myself. Even going to bed at 5am and trying to be up by 6am works. Ever tried waking up after an hour of sleep? It's practically impossible.`}</p>
    <p>{`Some might think it a bit strange to sleep with an iphone in their bed, but I've been doing that forever anyway - otherwise there's no chance of hearing the alarm.`}</p>
    <p>{`But not all is perfect.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/11/photo-2.png",
        "alt": null,
        "title": "Super polite when it wakes you up"
      }}></img></p>
    <p>{`What often ends up happening is that I will wake up when the alarm sounds (it's a veyr polite alarm too, all it takes to snooze is smacking it a bit), then be unable to crawl out of bed and eventually I just fall back asleep for another hour or two.`}</p>
    <p>{`But I'm sure I'll figure that one out eventually ... trying really really hard to actually go to bed at sensible hours might work. Of course there is a website for that called `}<a parentName="p" {...{
        "href": "http://sleepyti.me"
      }}>{`sleepyti.me`}</a>{`.`}</p>
    <p>{`That is, `}{`_`}{`if `}{`_`}{`I can get myself to even fall asleep before 2am.`}</p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://presurfer.blogspot.com/2011/10/bedtime-calculator.html"
        }}>{`Bedtime Calculator`}</a>{` (presurfer.blogspot.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://lemikegao.com/startup-sleep-setting-up-a-sleep-schedule-to-19349"
        }}>{`Choosing the right sleep schedule to maximize time and keep you healthy`}</a>{` (lemikegao.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.everydayhealth.com/sleep/101/be-a-smart-sleeper.aspx"
        }}>{`Be Smart About Sleep`}</a>{` (everydayhealth.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.everydayhealth.com/sleep/101/stages-of-sleep.aspx"
        }}>{`Sleep Stages`}</a>{` (everydayhealth.com)`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=0cdf25fb-aeff-4d02-b3bf-b42f97da63c8",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      